export const getLocalStorage = () => {
    const data = localStorage.getItem("list");
    if(data === null){
        return [];
    }
    else{
        return JSON.parse(data);
    }
}